import * as i0 from '@angular/core';
import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ResourceScope = /*#__PURE__*/function (ResourceScope) {
  ResourceScope[ResourceScope["RESOURCE_SCOPE_INVALID"] = 0] = "RESOURCE_SCOPE_INVALID";
  ResourceScope[ResourceScope["RESOURCE_SCOPE_NONE"] = 1] = "RESOURCE_SCOPE_NONE";
  ResourceScope[ResourceScope["RESOURCE_SCOPE_OWN"] = 2] = "RESOURCE_SCOPE_OWN";
  ResourceScope[ResourceScope["RESOURCE_SCOPE_OWN_UNOWNED"] = 3] = "RESOURCE_SCOPE_OWN_UNOWNED";
  ResourceScope[ResourceScope["RESOURCE_SCOPE_ALL"] = 4] = "RESOURCE_SCOPE_ALL";
  return ResourceScope;
}(ResourceScope || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var NamespaceContext = /*#__PURE__*/function (NamespaceContext) {
  NamespaceContext[NamespaceContext["NAMESPACE_CONTEXT_INVALID"] = 0] = "NAMESPACE_CONTEXT_INVALID";
  NamespaceContext[NamespaceContext["NAMESPACE_CONTEXT_PARTNER"] = 1] = "NAMESPACE_CONTEXT_PARTNER";
  NamespaceContext[NamespaceContext["NAMESPACE_CONTEXT_ACCOUNT_GROUP"] = 2] = "NAMESPACE_CONTEXT_ACCOUNT_GROUP";
  return NamespaceContext;
}(NamespaceContext || {});
var SpecialRestrictedValue = /*#__PURE__*/function (SpecialRestrictedValue) {
  SpecialRestrictedValue[SpecialRestrictedValue["INVALID"] = 0] = "INVALID";
  SpecialRestrictedValue[SpecialRestrictedValue["EMPTY"] = 1] = "EMPTY";
  SpecialRestrictedValue[SpecialRestrictedValue["ALL"] = 2] = "ALL";
  return SpecialRestrictedValue;
}(SpecialRestrictedValue || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums Index.
// *********************************

function enumStringToValue$5(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class PagedResponseMetadata {
  static fromProto(proto) {
    let m = new PagedResponseMetadata();
    m = Object.assign(m, proto);
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ListAssociatedUsersRequest {
  static fromProto(proto) {
    let m = new ListAssociatedUsersRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountId !== 'undefined') {
      toReturn['accountId'] = this.accountId;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListAssociatedUsersResponse {
  static fromProto(proto) {
    let m = new ListAssociatedUsersResponse();
    m = Object.assign(m, proto);
    if (proto.associations) {
      m.associations = proto.associations.map(UserAssociations.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.associations !== 'undefined' && this.associations !== null) {
      toReturn['associations'] = 'toApiJson' in this.associations ? this.associations.toApiJson() : this.associations;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class UserAssociations {
  static fromProto(proto) {
    let m = new UserAssociations();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FieldMask {
  static fromProto(proto) {
    let m = new FieldMask();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paths !== 'undefined') {
      toReturn['paths'] = this.paths;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class GetPermissionsRequest {
  static fromProto(proto) {
    let m = new GetPermissionsRequest();
    m = Object.assign(m, proto);
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class GetPermissionsResponse {
  static fromProto(proto) {
    let m = new GetPermissionsResponse();
    m = Object.assign(m, proto);
    if (proto.permissions) {
      m.permissions = Permissions.fromProto(proto.permissions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.permissions !== 'undefined' && this.permissions !== null) {
      toReturn['permissions'] = 'toApiJson' in this.permissions ? this.permissions.toApiJson() : this.permissions;
    }
    return toReturn;
  }
}
class Namespace {
  static fromProto(proto) {
    let m = new Namespace();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespaceId !== 'undefined') {
      toReturn['namespaceId'] = this.namespaceId;
    }
    if (typeof this.namespaceType !== 'undefined') {
      toReturn['namespaceType'] = this.namespaceType;
    }
    return toReturn;
  }
}
class Permissions {
  static fromProto(proto) {
    let m = new Permissions();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = proto.namespace.map(Namespace.fromProto);
    }
    if (proto.contacts) {
      m.contacts = Resource.fromProto(proto.contacts);
    }
    if (proto.activities) {
      m.activities = Resource.fromProto(proto.activities);
    }
    if (proto.companies) {
      m.companies = Resource.fromProto(proto.companies);
    }
    if (proto.opportunities) {
      m.opportunities = Resource.fromProto(proto.opportunities);
    }
    if (proto.customObjects) {
      m.customObjects = Resource.fromProto(proto.customObjects);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    if (typeof this.contacts !== 'undefined' && this.contacts !== null) {
      toReturn['contacts'] = 'toApiJson' in this.contacts ? this.contacts.toApiJson() : this.contacts;
    }
    if (typeof this.activities !== 'undefined' && this.activities !== null) {
      toReturn['activities'] = 'toApiJson' in this.activities ? this.activities.toApiJson() : this.activities;
    }
    if (typeof this.companies !== 'undefined' && this.companies !== null) {
      toReturn['companies'] = 'toApiJson' in this.companies ? this.companies.toApiJson() : this.companies;
    }
    if (typeof this.restrictedToMarketId !== 'undefined') {
      toReturn['restrictedToMarketId'] = this.restrictedToMarketId;
    }
    if (typeof this.opportunities !== 'undefined' && this.opportunities !== null) {
      toReturn['opportunities'] = 'toApiJson' in this.opportunities ? this.opportunities.toApiJson() : this.opportunities;
    }
    if (typeof this.customObjects !== 'undefined' && this.customObjects !== null) {
      toReturn['customObjects'] = 'toApiJson' in this.customObjects ? this.customObjects.toApiJson() : this.customObjects;
    }
    return toReturn;
  }
}
class Resource {
  static fromProto(proto) {
    let m = new Resource();
    m = Object.assign(m, proto);
    if (proto.readScope) {
      m.readScope = enumStringToValue$2(ResourceScope, proto.readScope);
    }
    if (proto.writeScope) {
      m.writeScope = enumStringToValue$2(ResourceScope, proto.writeScope);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.readScope !== 'undefined') {
      toReturn['readScope'] = this.readScope;
    }
    if (typeof this.writeScope !== 'undefined') {
      toReturn['writeScope'] = this.writeScope;
    }
    return toReturn;
  }
}
class UpdatePermissionsRequest {
  static fromProto(proto) {
    let m = new UpdatePermissionsRequest();
    m = Object.assign(m, proto);
    if (proto.permissions) {
      m.permissions = Permissions.fromProto(proto.permissions);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.permissions !== 'undefined' && this.permissions !== null) {
      toReturn['permissions'] = 'toApiJson' in this.permissions ? this.permissions.toApiJson() : this.permissions;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class HasViewAccessResponseAccess {
  static fromProto(proto) {
    let m = new HasViewAccessResponseAccess();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.viewId !== 'undefined') {
      toReturn['viewId'] = this.viewId;
    }
    if (typeof this.hasAccess !== 'undefined') {
      toReturn['hasAccess'] = this.hasAccess;
    }
    return toReturn;
  }
}
class GetRestrictionsRequest {
  static fromProto(proto) {
    let m = new GetRestrictionsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.viewId !== 'undefined') {
      toReturn['viewId'] = this.viewId;
    }
    return toReturn;
  }
}
class GetRestrictionsResponse {
  static fromProto(proto) {
    let m = new GetRestrictionsResponse();
    m = Object.assign(m, proto);
    if (proto.restrictions) {
      m.restrictions = proto.restrictions.map(GetRestrictionsResponseRestriction.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.restrictions !== 'undefined' && this.restrictions !== null) {
      toReturn['restrictions'] = 'toApiJson' in this.restrictions ? this.restrictions.toApiJson() : this.restrictions;
    }
    return toReturn;
  }
}
class GetUserIdentifiersRequest {
  static fromProto(proto) {
    let m = new GetUserIdentifiersRequest();
    m = Object.assign(m, proto);
    if (proto.namespaceContext) {
      m.namespaceContext = enumStringToValue(NamespaceContext, proto.namespaceContext);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.namespaceContext !== 'undefined') {
      toReturn['namespaceContext'] = this.namespaceContext;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    return toReturn;
  }
}
class GetUserIdentifiersResponse {
  static fromProto(proto) {
    let m = new GetUserIdentifiersResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userIdentifiers !== 'undefined') {
      toReturn['userIdentifiers'] = this.userIdentifiers;
    }
    return toReturn;
  }
}
class HasViewAccessRequest {
  static fromProto(proto) {
    let m = new HasViewAccessRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.viewIds !== 'undefined') {
      toReturn['viewIds'] = this.viewIds;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.ownerId !== 'undefined') {
      toReturn['ownerId'] = this.ownerId;
    }
    return toReturn;
  }
}
class HasViewAccessResponse {
  static fromProto(proto) {
    let m = new HasViewAccessResponse();
    m = Object.assign(m, proto);
    if (proto.access) {
      m.access = proto.access.map(HasViewAccessResponseAccess.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.access !== 'undefined' && this.access !== null) {
      toReturn['access'] = 'toApiJson' in this.access ? this.access.toApiJson() : this.access;
    }
    return toReturn;
  }
}
class ListNamespacesRequest {
  static fromProto(proto) {
    let m = new ListNamespacesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    return toReturn;
  }
}
class ListNamespacesResponse {
  static fromProto(proto) {
    let m = new ListNamespacesResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespaces !== 'undefined') {
      toReturn['namespaces'] = this.namespaces;
    }
    return toReturn;
  }
}
class GetRestrictionsResponseRestriction {
  static fromProto(proto) {
    let m = new GetRestrictionsResponseRestriction();
    m = Object.assign(m, proto);
    if (proto.groupId) {
      m.groupId = proto.groupId.map(GetRestrictionsResponseRestrictionValue.fromProto);
    }
    if (proto.ownerId) {
      m.ownerId = proto.ownerId.map(GetRestrictionsResponseRestrictionValue.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.viewId !== 'undefined') {
      toReturn['viewId'] = this.viewId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.groupId !== 'undefined' && this.groupId !== null) {
      toReturn['groupId'] = 'toApiJson' in this.groupId ? this.groupId.toApiJson() : this.groupId;
    }
    if (typeof this.ownerId !== 'undefined' && this.ownerId !== null) {
      toReturn['ownerId'] = 'toApiJson' in this.ownerId ? this.ownerId.toApiJson() : this.ownerId;
    }
    return toReturn;
  }
}
class GetRestrictionsResponseRestrictionValue {
  static fromProto(proto) {
    let m = new GetRestrictionsResponseRestrictionValue();
    m = Object.assign(m, proto);
    if (proto.other) {
      m.other = enumStringToValue(SpecialRestrictedValue, proto.other);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.stringValue !== 'undefined') {
      toReturn['stringValue'] = this.stringValue;
    }
    if (typeof this.other !== 'undefined') {
      toReturn['other'] = this.other;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'platform-users-api.vendasta-local.com',
  'test': '',
  'demo': 'platform-users-demo.apigateway.co',
  'prod': 'platform-users-prod.apigateway.co',
  'production': 'platform-users-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let PermissionsApiService = /*#__PURE__*/(() => {
  class PermissionsApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getPermissions(r) {
      const request = r.toApiJson ? r : new GetPermissionsRequest(r);
      return this.http.post(this._host + "/platformusers.v1.PermissionsService/GetPermissions", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetPermissionsResponse.fromProto(resp)));
    }
    updatePermissions(r) {
      const request = r.toApiJson ? r : new UpdatePermissionsRequest(r);
      return this.http.post(this._host + "/platformusers.v1.PermissionsService/UpdatePermissions", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  PermissionsApiService.ɵfac = function PermissionsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PermissionsApiService)();
  };
  PermissionsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PermissionsApiService,
    factory: PermissionsApiService.ɵfac,
    providedIn: 'root'
  });
  return PermissionsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let SMBAssociationsApiService = /*#__PURE__*/(() => {
  class SMBAssociationsApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    listAssociatedUsers(r) {
      const request = r.toApiJson ? r : new ListAssociatedUsersRequest(r);
      return this.http.post(this._host + "/platformusers.v1.SMBAssociationsService/ListAssociatedUsers", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAssociatedUsersResponse.fromProto(resp)));
    }
  }
  SMBAssociationsApiService.ɵfac = function SMBAssociationsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SMBAssociationsApiService)();
  };
  SMBAssociationsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SMBAssociationsApiService,
    factory: SMBAssociationsApiService.ɵfac,
    providedIn: 'root'
  });
  return SMBAssociationsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let UsersApiService = /*#__PURE__*/(() => {
  class UsersApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    listNamespaces(r) {
      const request = r.toApiJson ? r : new ListNamespacesRequest(r);
      return this.http.post(this._host + "/platformusers.v1.UsersService/ListNamespaces", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListNamespacesResponse.fromProto(resp)));
    }
    getUserIdentifiers(r) {
      const request = r.toApiJson ? r : new GetUserIdentifiersRequest(r);
      return this.http.post(this._host + "/platformusers.v1.UsersService/GetUserIdentifiers", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetUserIdentifiersResponse.fromProto(resp)));
    }
  }
  UsersApiService.ɵfac = function UsersApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || UsersApiService)();
  };
  UsersApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: UsersApiService,
    factory: UsersApiService.ɵfac,
    providedIn: 'root'
  });
  return UsersApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let ViewAccessApiService = /*#__PURE__*/(() => {
  class ViewAccessApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    hasViewAccess(r) {
      const request = r.toApiJson ? r : new HasViewAccessRequest(r);
      return this.http.post(this._host + "/platformusers.v1.ViewAccessService/HasViewAccess", request.toApiJson(), this.apiOptions()).pipe(map(resp => HasViewAccessResponse.fromProto(resp)));
    }
    getRestrictions(r) {
      const request = r.toApiJson ? r : new GetRestrictionsRequest(r);
      return this.http.post(this._host + "/platformusers.v1.ViewAccessService/GetRestrictions", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetRestrictionsResponse.fromProto(resp)));
    }
  }
  ViewAccessApiService.ɵfac = function ViewAccessApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ViewAccessApiService)();
  };
  ViewAccessApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ViewAccessApiService,
    factory: ViewAccessApiService.ɵfac,
    providedIn: 'root'
  });
  return ViewAccessApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Index.
// *********************************

// MANUALLY CREATED FILE
// Don't delete this by mistake when you update the SDK with mscli!

/**
 * Generated bundle index. Do not edit.
 */

export { Access, FieldMask, GetPermissionsRequest, GetPermissionsResponse, GetRestrictionsRequest, GetRestrictionsResponse, GetRestrictionsResponseRestriction, GetRestrictionsResponseRestrictionValue, GetUserIdentifiersRequest, GetUserIdentifiersResponse, HasViewAccessRequest, HasViewAccessResponse, HasViewAccessResponseAccess, HostService, ListAssociatedUsersRequest, ListAssociatedUsersResponse, ListNamespacesRequest, ListNamespacesResponse, Namespace, NamespaceContext, PagedRequestOptions, PagedResponseMetadata, Permissions, PermissionsApiService, Resource, ResourceScope, SMBAssociationsApiService, SpecialRestrictedValue, UpdatePermissionsRequest, UserAssociations, UsersApiService, ViewAccessApiService };
